
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings/users",
      function () {
        return require("private-next-pages/[company]/settings/users.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/settings/users"])
      });
    }
  